module.exports = __webpack_public_path__ + "static/media/uuno-turhapuro.ea58d798.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Videos/uuno-turhapuro.webm
// module id = 61
// module chunks = 0